import { Theme } from '@benchlabs/react-design-system';

export const findGlobalServicesStyles = (theme: Theme) => ({
  '.MuiStack-root': {
    gap: '8px',
  },

  '.MuiTypography-root': {
    color: theme.palette.text.secondary,
    paddingTop: '10px', //Aligns the text with the input field when an error message is displayed
  },
});
